export default __webpack_public_path__ + "static/media/Superdiversity-website-metadata-Sydney.167853fe.pdf";